var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkSimpleBreak = function SvgIconLinkSimpleBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.242 2.257c-1.459 0-2.858.58-3.89 1.61L9.7 6.522a1 1 0 1 0 1.414 1.414l2.654-2.653a3.501 3.501 0 1 1 4.95 4.951l-2.652 2.654a1 1 0 1 0 1.414 1.414l2.653-2.653a5.501 5.501 0 0 0-3.89-9.391M7.935 11.113A1 1 0 0 0 6.521 9.7l-2.653 2.653a5.501 5.501 0 1 0 7.78 7.78L14.3 17.48a1 1 0 0 0-1.414-1.414l-2.653 2.653a3.502 3.502 0 0 1-4.952-4.951z"
  }))));
};
export default SvgIconLinkSimpleBreak;